import { ISigninLog } from '@api/types/sign-in.type';
import { Table } from '@hyperflake/react-ui-library';
import { CountryDialCodeList } from 'modules/shared/helpers/shared.constants';
import moment from 'moment';
import { Link } from 'react-router-dom';

interface DailyActivityListProps {
    isLoading: boolean;
    dailyActivity: ISigninLog[];
}

const DailyActivityList = ({ isLoading, dailyActivity }: DailyActivityListProps) => {
    const getCountry = (countryCode: string = '') => {
        const selectedCountry = CountryDialCodeList.find(
            (country) => countryCode.toLowerCase() === country?.countryCode?.toLowerCase()
        );
        return selectedCountry?.countryName || '';
    };

    return (
        <Table
            className="mt-6"
            borderStyle="divider"
            hover={false}
            isLoading={isLoading}
            data={dailyActivity}
            columns={[
                { header: 'S No' }, // <── ADDED
                { header: 'ID' },
                { header: 'Date & Time' },
                { header: 'Name' },
                { header: 'Username' },
                { header: 'Client' },
                { header: 'Ip Address' },
                { header: 'Country' },
            ]}
            renderRow={(
                row,
                index // <── GET index from renderRow callback
            ) => (
                <Table.Row key={row._id}>
                    <Table.Cell>{index + 1}</Table.Cell> {/* <── SERIAL NUMBER */}
                    <Table.Cell>{row._id}</Table.Cell>
                    <Table.Cell>
                        <span>{moment(row.createdAt, 'YYYYMMDDHHmmss').format('HH:mm A - DD MMM YYYY')}</span>
                    </Table.Cell>
                    <Table.Cell>{row?.user?.name}</Table.Cell>
                    <Table.Cell>
                        <Link
                            to={`/clients/${row.user.client._id}/users/${row.user._id}/edit-user`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {row?.user.username}
                        </Link>
                    </Table.Cell>
                    <Table.Cell>
                        <Link
                            to={`/clients/${row.user.client._id}/client-details`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {row.user.client.name}
                        </Link>
                    </Table.Cell>
                    <Table.Cell>{row?.userIp}</Table.Cell>
                    <Table.Cell>
                        <div className="flex items-center gap-2">
                            <img
                                className="rounded-full w-6 h-6"
                                src={`/flags/${row?.country?.toLowerCase() || ''}.svg`}
                                alt={getCountry(row.country)}
                            />
                            <div>{getCountry(row.country)}</div>
                        </div>
                    </Table.Cell>
                </Table.Row>
            )}
        />
    );
};

export default DailyActivityList;
